import { FunctionComponent, useEffect, useLayoutEffect, useState } from "react";
import StarIcon from "@mui/icons-material/Star"; // Import a star icon from MUI
import "./Instruction.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import {
  clearListExamID,
  listExamID,
} from "../../Redux/Slices/Exam/ListExamIDSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import { clearlistInstructionExamID, listInstructionExamID } from "../../Redux/Slices/Exam/ListinstructionExamIDSlice";
import {
  clearlistStudentExam,
  listStudentExam,
} from "../../Redux/Slices/StudentExam/ListStudentExamSlice";
import {
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  CssBaseline,
  Grid,
  SvgIcon,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import { addOpenSection, clearAddOpenSectionResponse } from "../../Redux/Slices/OpenSection/AddOpenSectionSlice";
import InfoIcon from "@mui/icons-material/Info";
import AppBarnav from "../../Components/AppBar/AppBar";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

interface InstructionProps { }

const Instruction: FunctionComponent<InstructionProps> = () => {
  // Create an array of instruction objects
  const navigate = useNavigate();
  const { state: exam_id } = useLocation();

  const { data: listInstructionExamSlice } = useAppSelector(
    (state) => state.ListInstructionExamSlice
  );
  const ListInstructionExamSlices: any = listInstructionExamSlice?.data;

  const ListInstruction = ListInstructionExamSlices?.exam_instructions;

  const { data: listexamlist, isLoading: listexamlistLoading } = useAppSelector(
    (state) => state.ListExamIDSlice
  );

  const [details, setDetails] = useState<ILoginResponse>({});

  const { data: listStudentExamSlice } = useAppSelector(
    (state) => state.ListStudentExamSlice
  );
  const ListStudentExam: any = listStudentExamSlice?.data;

  const { isLoading: addOpenSectionLoading, data: addOpenSectionData } = useAppSelector(
    (state) => state.AddOpenSectionSlice
  );

  const [isNavigating, setIsNavigating] = useState(false);

  useLayoutEffect(() => {
    dispatch(clearlistStudentExam());
    const timeoutId = setTimeout(() => {
      dispatch(listStudentExam());
    }, 1500); // 5000 milliseconds = 5 seconds
    return () => clearTimeout(timeoutId);
  }, []);

  useLayoutEffect(() => {
    dispatch(clearlistInstructionExamID());
    dispatch(listInstructionExamID({ exam_id: exam_id, }));
    dispatch(clearAddOpenSectionResponse());
  }, [exam_id]);

  useLayoutEffect(() => {
    if (ListStudentExam) {
      const timeout = setTimeout(() => {
        dispatch(listExamID({
          stud_exam_id: ListStudentExam?.id
          //  created_on: timestamp,
          //   updated_on: timestamp,
        }));
      }, 2000); // 5000 milliseconds = 5 seconds
      return () => clearTimeout(timeout);
    }
  }, [ListStudentExam]);

  useEffect(() => {
    // Check if "details" exists in sessionStorage before decoding
    const storedDetails = sessionStorage.getItem("details");
    if (storedDetails) {
      const userDetails = decode(storedDetails);
      setDetails(userDetails);
    }
    dispatch(clearListExamID());

    // Only re-run if `ListInstructionExamSlices` is relevant
  }, [ListInstructionExamSlices]);

  const [showLoading, setShowLoading] = useState(true);

  // Set the initial "Loading questions" display
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      setShowLoading(false); // Allow normal loading state to take over
    }, 20); // 5 seconds
    return () => clearTimeout(initialTimeout);
  }, []);

  const handleButtonClick = () => {
    setIsNavigating(true);
    sessionStorage.setItem(
      "timestorage",
      ListInstructionExamSlices?.total_timing
    );
    dispatch(
      addOpenSection({
        student_exam_id: ListStudentExam?.id,
        remaining_time: null,
        closed: false,
        question_type_id:
          listexamlist?.data?.questions_by_type?.[0]?.question_type_id,
      })
    );
  };

  useEffect(() => {
    if (isNavigating && !addOpenSectionLoading && addOpenSectionData) {
      navigate("/examparticipation", { state: { examID: exam_id } });
      setIsNavigating(false);
    }
  }, [isNavigating, addOpenSectionLoading, addOpenSectionData]);
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const now = new Date();
  const pad = (n: any) => String(n).padStart(2, "0");

  const timestamp =
    `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}` +
    `T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

  // question count
  const totalQuestionCount =
    ListInstructionExamSlices?.questions_by_type?.reduce(
      (sum: any, item: any) => sum + item.question_count,
      0
    );

  return (
    <>
      <Box sx={{ display: "flex", height: "1px" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#FFFFFF",
            display: "flex",
            boxShadow: "0px 4px 40px 0px #0000000D",
          }}
        >
          <Toolbar
            sx={{
              minHeight: "0px",
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "0px",
              paddingRight: "0px",
              margin: "0% 8%",
              height: "50px",
            }}
          >
            <Typography variant="h6" noWrap component="div">
              <SvgIcon
                sx={{
                  width: "123px",
                  height: "50px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
                color="primary"
                component={Logo}
                inheritViewBox
              />
            </Typography>
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  color: "#009dff",
                  fontSize: "16px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(-1); // Go back to previous page
                }}
              >
                <ArrowBackIosIcon sx={{ color: "#009dff" }} />
                <div style={{ color: "#009dff", fontSize: "15px" }}>
                  {" "}
                  Back To Exam
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{ flexGrow: 1, height: "100vh", width: "100%" }}
        >
          <Outlet />
          {(addOpenSectionLoading) && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                zIndex: 9999,
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: "50px",
          backgroundColor: "#f5f9ff",
          minHeight: "100vh",
          py: 5,
          px: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        {!ListInstructionExamSlices ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={4} justifyContent="center" maxWidth="lg">
            <Grid item xs={12}>
              <Typography
                variant="h3"
                fontWeight="bold"
                textAlign="center"
                color="#1e3a8a"
              >
                {ListInstructionExamSlices?.exam_name}
              </Typography>
              <Typography
                variant="body1"
                textAlign="center"
                maxWidth="700px"
                mx="auto"
                fontSize="19px"
                mt={1}
                color="#4b5563"
              >
                {ListInstructionExamSlices?.exam_description}
              </Typography>
            </Grid>

            {/* Instructions Card */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  p: 2,
                  borderRadius: "12px",
                  boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      color: "#111827",
                      fontSize: "1.7rem",
                      marginBottom: "15px",
                    }}
                  >
                    Please Read Instructions Carefully
                  </Typography>

                  <Box mb={2}>
                    {ListInstruction?.map((item: any, index: any) => (
                      <Typography variant="body1" key={index} gutterBottom>
                        {/* <div key={index} className="instructionitem"> */}

                        <div
                          style={{
                            fontSize: "18px",
                            marginBottom: "20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              height: "20px",
                              // width: "20px",
                              backgroundColor: "#009dff",
                              color: "#374151",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "9px",
                              // marginRight: "8px",
                            }}
                          >
                            <span
                              style={{
                                height: "4px",
                                width: "4px",
                                backgroundColor: "#ffffff",
                                borderRadius: "50%",
                                display: "inline-block",
                              }}
                            />
                          </span>

                          {item?.instruction}
                        </div>
                      </Typography>
                    ))}
                  </Box>

                  {listexamlist?.data ? (
                    <Box
                      display="flex"
                      gap={2}
                      flexDirection={isMobile ? "column" : "row"}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "17px",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#009dff",
                          },
                        }}
                        onClick={handleButtonClick}
                      >
                        Start Test
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "17px",
                          backgroundColor: "white",
                          color: "#009dff",
                          borderColor: "#009dff",
                          "&:hover": {
                            borderColor: "#009dff",

                            backgroundColor: "white",
                            color: "#009dff",
                          },
                        }}
                        onClick={() => {
                          navigate(-1); // Go back to previous page
                        }}
                      >
                        Back To Home
                      </Button>
                    </Box>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={true}
                        onClick={handleButtonClick}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textTransform: "capitalize",
                          fontSize: "17px",
                          color: "white",

                          "&:hover": {
                            backgroundColor: "#009dff",
                            color: "white",
                          },
                        }}
                      >
                        <div>Loading questions</div>
                        <div>
                          <CircularProgress
                            size={20}
                            sx={{
                              color: "white",
                              marginLeft: "10px",
                            }}
                          />
                        </div>
                      </Button>
                      <div className="vaidationforwriting">
                        <InfoIcon />
                        <div>
                          Please wait while the questions are being prepared. The
                          test will begin shortly{" "}
                        </div>
                      </div>
                    </>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Test Includes Card */}
            <Grid item xs={12} md={3}>
              <Card
                sx={{
                  // p: 2,
                  borderRadius: "12px",
                  backgroundColor: "#f5faff",
                  boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                  border: "1px solid #e0f0ff",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                    sx={{ color: "#111827", fontSize: "1.7rem" }}
                  >
                    Exam Includes
                  </Typography>

                  {ListInstructionExamSlices?.questions_by_type.map(
                    (item: any) => (
                      <Box
                        key={item.question_type_id}
                        sx={{
                          p: 2,
                          borderRadius: "10px",
                          backgroundColor: "white",
                          mb: 2,
                          border: "1px solid #dceeff",
                        }}
                      >
                        <Typography
                          sx={{ fontWeight: "bold", fontSize: "1.3rem" }}
                        >
                          {item.question_type_name}
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1,
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "1.3rem",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                            Question type:
                          </span>
                          <div style={{ fontWeight: 500, color: "black" }}>
                            {item.question_type_name === "Writing"
                              ? "Written"
                              : "MCQ"}
                          </div>
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1,
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "1.3rem",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                            Question count:
                          </span>
                          <div style={{ fontWeight: 500, color: "black" }}>
                            {item.question_count}
                          </div>
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1,
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "1.3rem",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                            Duration:
                          </span>
                          <div style={{ fontWeight: 500, color: "black" }}>
                            {item.duration}
                          </div>
                        </Typography>
                      </Box>
                    )
                  )}

                  <Box
                    sx={{
                      borderTop: "1px solid #e0e0e0",
                      pt: 2,
                      display: "flex",
                      justifyContent: "space-around",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          {" "}
                          <AccessTimeIcon
                            sx={{ color: "#009DFF", fontSize: "3rem" }}
                          />
                        </div>
                        <Typography
                          variant="caption"
                          sx={{ color: "#666", fontSize: "1rem" }}
                        >
                          TOTAL DURATION
                        </Typography>
                        <Typography
                          fontWeight="bold"
                          variant="body2"
                          sx={{ fontSize: "1.2rem" }}
                        >
                          {ListInstructionExamSlices?.total_timing}
                        </Typography>
                      </Box>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <TaskAltIcon
                            sx={{ color: "#009DFF", fontSize: "3rem" }}
                          />
                        </div>

                        <Typography
                          variant="caption"
                          sx={{ color: "#666", fontSize: "1rem" }}
                        >
                          QUESTIONS
                        </Typography>
                        <Typography
                          fontWeight="bold"
                          variant="body2"
                          sx={{ fontSize: "1.2rem" }}
                        >
                          {totalQuestionCount ?? "-"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </Box>
    </>
  );
};

export default Instruction;
